import { render, staticRenderFns } from "./DataPelatihan.vue?vue&type=template&id=23f70d70&"
import script from "./DataPelatihan.vue?vue&type=script&lang=js&"
export * from "./DataPelatihan.vue?vue&type=script&lang=js&"
import style0 from "./DataPelatihan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports